import { render } from "./SubscribeWindow.vue?vue&type=template&id=bffeb562&scoped=true"
import script from "./SubscribeWindow.vue?vue&type=script&lang=js"
export * from "./SubscribeWindow.vue?vue&type=script&lang=js"

import "./SubscribeWindow.vue?vue&type=style&index=0&id=bffeb562&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bffeb562"

export default script